import { prop, propOr, pipe, filter } from 'core/utils';

export const mediateSelectedListInfoDependent = propOr({displayName : 'loading...'}, 'selectedList');
export const mediateTaskListsInfoDependent = pipe(
    prop('taskLists'),
    filter((list) => {
        return list.wellknownListName !== 'defaultList';
    })
);
